export enum TreeMenuAction{
    SHOW_NODES_FROM_HERE="SHOW_NODES_FROM_HERE",
    SHOW_ONLY_CHILDS_CHAIN="SHOW_ONLY_CHILDS_CHAIN",
    SHOW_ONLY_CHILDS="SHOW_ONLY_CHILDS",
    SHOW_NODE="SHOW_NODE",
    EXPORT_TO_JSON="EXPORT_TO_JSON",
    EXPORT_HYPERFLOWS_TO_JSON="EXPORT_HYPERFLOWS_TO_JSON",
    IMPORT_JSON="IMPORT_JSON"
}